jQuery(document).ready(function ($) {
    (function hideWooModalWithoutDeletingFromDOM() {
        $('.cart-message-modal .btn-close, .cart-message-modal .return-shopping-el').each(function () {
            $(this).on('click', function (e) {
                $('.woocommerce-message.cart-message').fadeOut();
            })
        });
    })();

    (function addProductToCart() {
        $('body').on('click', '.add_to_cart, .single_add_to_cart_button', function (e) {
            e.preventDefault();

            $('.woocommerce-message.cart-message').appendTo('body');

            const $button = $(this);

            $button.addClass('loading');

            const productTitle = $button.data('product_title');
            const quantity = $button
                .closest('.product-quantity-section-wrap')
                .find('.qty')
                .val();

            const preferredShipping =
                $('input[name="preferred_shipping"]:checked').val() || 'flat_rate';

            $.ajax({
                type: 'POST',
                url: wc_add_to_cart_params.wc_ajax_url.toString().replace('%%endpoint%%', 'add_to_cart'),
                data: {
                    product_id: $button.data('product_id'),
                    quantity,
                    preferred_shipping: preferredShipping,
                },
                beforeSend: function () {
                    $('.cart-message .cart-content-message-default .product-title').text(productTitle);
                },
                success: function (response) {
                    if (response && response.fragments) {
                        $.each(response.fragments, function (key, value) {
                            $(key).replaceWith(value);
                        });
                    }

                    $('.woocommerce-message.cart-message').fadeIn();
                },
                complete: function () {
                    $button.removeClass('loading');
                }
            });
        });
    })();

    (function updateHeaderCartCount() {
        fetch('/wp-json/wc/store/v1/cart', {
            cache: 'no-store'
        })
        .then(response => response.json())
        .then(cart => {

            const $cart = $('.cart.cart-header');

            if (!$cart.length) {
                return;
            }

            const count = cart.items_count;
            const $count = $cart.find('.count');

            if (count > 0) {

                if ($count.length) {
                    $count.text(count);
                } else {
                    $cart.find('.cart-link').append(
                        `<span class="count">${count}</span>`
                    );
                }
            } else {
                $count.remove();
            }
        })
        .catch(error => {
            console.error('Unable to sync cart count:', error);
        });
    })();

    (function activateReviewsTab() {
        setTimeout(function () {
            let activeTab = $('.woocommerce-tabs ul.tabs li:not(.disabled)').first().attr('aria-controls');

            if (activeTab) activeTab.trim().split(/\s+/)[0];

            $('.woocommerce-tabs ul.tabs li').removeClass('active');
            $('.woocommerce-tabs ul.tabs li[aria-controls=' + activeTab + ']').addClass('active');
            $('.woocommerce-Tabs-panel').hide();
            $(`#${activeTab}`).show();
        }, 500);

        $('.woocommerce-Tabs-panel:empty').each(function () {
            var tabId = $(this).attr('id');
            $('ul.tabs li a[href="#' + tabId + '"]').parent().addClass('disabled');
        });

        var orderedTabs = ['description', 'additional_information', 'features-benefits', 'reviews'];
        var $tabList = $('.woocommerce-tabs ul.tabs');

        orderedTabs.forEach(function (tab) {
            var $tabItem = $tabList.find('li.' + tab + '_tab');
            if ($tabItem.length) {
                $tabItem.appendTo($tabList);
            }
        });
    })();

    function setRateInThanksMessage() {
        let rating = $('input[name="rating"]:checked').val();
        $('.thanks-for-review .stars span span').removeClass('active');
        $('.thanks-for-review .stars span span').slice(0, rating).addClass('active');
    }

    function validateEmailServer(email, callback) {
        return new Promise(function (resolve) {
            $.ajax({
                url: "/wp-admin/admin-ajax.php?action=ajax_validate_email_domain",
                type: 'POST',
                data: {
                    action: 'validate_email_domain',
                    email: email
                },
                success: function (response) {
                    resolve(response.success);
                },
                error: function () {
                    resolve(false);
                }
            });
        })
    }

    async function customValidation(data) {
        let errors = {};
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const isValidDomain = await validateEmailServer(data.email);
        const linkRegex = /\b(?:https?:\/\/|www\.)\S+/i;

        if (data.botcheck && data.botcheck.trim() !== '') {
            errors['botcheck'] = 'Spam detected.';
        }

        if (!data.rating) errors['rating'] = 'Rating field is required.';

        if (!data.comment) {
            errors['comment'] = 'Review field is required.';
        } else if (data.comment.length > 1000) {
            errors['comment'] = 'Review field must be less than 1000 characters.';
        } else if (linkRegex.test(data.comment)) {
            errors['comment'] = 'Submission failed. To continue, remove any links from your review.';
        }

        if (!data.author) {
            errors['author'] = 'Name field is required.';
        } else if (data.author.length > 30) {
            errors['author'] = 'Name field must be less than 30 characters.';
        }

        if (!data.email) {
            errors['email'] = 'Email field is required.';
        } else if (!emailRegex.test(data.email)) {
            errors['email'] = 'Enter a valid email address.';
        } else if (!isValidDomain) {
            errors['email'] = 'Enter a valid email domain.';
        } else if (data.author.length > 30) errors['email'] = 'Email field must be less than 30 characters.';

        return errors;
    }

    function showValidationErrors(errors) {
        $('.validation-error').remove();

        $.each(errors, function (field, message) {
            const $field = $(`.comment-form-${field} > label`);

            if ($field.length) {
                $field.after($('<span class="validation-error"></span>').text(message));
            }
        });

        $('#commentform input, #commentform textarea').on('input', function () {

            if ($(this).attr('type') == 'radio') {
                $(this).parent().parent().parent().find('.validation-error').remove();
            } else $(this).parent('p').find('.validation-error').remove();
        });
    }

    (function addReviewsUsingAjax() {
        $(document).on('show.bs.modal', '#reviewModal', function () {
            $(this).appendTo('body');
        });

        $('#commentform .form-submit .submit-btn').on('click', async function (e) {
            e.preventDefault();
            $(this).addClass('loading');

            if (grecaptcha) return;

            grecaptcha.ready(function () {
                grecaptcha.execute('6LdCuBorAAAAAAcRAwQ01Z-1DsvNQIHQrHp4LkA8', {action: 'review'}).then(async function (token) {
                    let formData = $('#commentform').serialize() + '&g-recaptcha-response-v3=' + encodeURIComponent(token);

                    let formatedData = $('#commentform').serializeArray().reduce(function (obj, item) {
                        obj[item.name] = item.value;
                        return obj;
                    }, {});

                    const validationErrors = await customValidation(formatedData);
                    if (Object.keys(validationErrors).length) {
                        $('#commentform button.submit-btn').removeClass('loading');
                        return showValidationErrors(validationErrors);
                    }

                    sendReviewForm(formData)
                });
            });
        });

        let v2_rendered = false;

        window.onRecaptchaV2Submit = function (token) {
            $('#g-recaptcha-response').val(token);
            const formData = $('#commentform').serialize() + '&g-recaptcha-response-v2=' + encodeURIComponent(token);
            sendReviewForm(formData);
        }

        function sendReviewForm(formData) {
            $.ajax({
                type: 'POST',
                url: wc_add_to_cart_params.ajax_url,
                data: formData + '&action=ajaxcomments',
                beforeSend: function () {
                    $('.wc-review-message').remove();
                    setRateInThanksMessage();
                },
                success: function (response) {
                    $('#commentform button.submit-btn').removeClass('loading');

                    if (response.success === false) {
                        showBackendError(response.message || 'Unknown error occurred.');

                        if (response.need_v2 || (response.message && response.message.includes('Suspicious'))) {
                            $('#recaptcha-v2-wrapper').slideDown();
                        }

                        return;
                    }

                    $('#commentform')[0].reset();
                    $('#review_form').fadeOut();
                    $('#recaptcha-v2-wrapper').fadeOut();
                    setTimeout(() => $('.thanks-for-review').fadeIn(), 500);
                },
                error: function (xhr) {
                    $('#commentform button.submit-btn').prop('disabled', false);

                    if (xhr.responseText) {
                        const responseText = new DOMParser().parseFromString(xhr.responseText, 'text/html'),
                            message = responseText.documentElement.textContent ? responseText.documentElement.textContent : 'Something went wrong. Please try again.';

                        showBackendError(message);

                        if (xhr.responseText.includes('Suspicious')) {
                            $('#recaptcha-v2-wrapper').fadeIn();
                        }
                    }
                },
                complete: function () {
                    $('.thanks-for-review .close-modal').on('click', function () {
                        setTimeout(function () {
                            $('#review_form').fadeIn();
                            $('.thanks-for-review').fadeOut();
                        }, 500);
                    });
                }
            });
        }

        function showBackendError(message) {
            $('.wc-review-message').remove();

            const $msg = $('<div>', {
                class: 'wc-review-message error',
                text: message
            }).css({
                padding: '10px',
                marginBottom: '15px',
                borderRadius: '5px',
                color: '#721c24',
                backgroundColor: '#f8d7da',
                border: '1px solid #f5c6cb'
            });
            $('#commentform').prepend($msg);
        }
    })();

    (function showMoreReviews() {
        let $reviewList = $('#reviews .commentlist'),
            $loadMore = $('#reviews .load-more'),
            $loadLess = $('#reviews .load-less');

        $reviewList.find('.comment:not(:first-child),.review').each(function () {
            $(this).fadeOut()
        });

        $loadMore.on('click', function () {
            $reviewList.find('.comment:not(:first-child),.review').each(function () {
                $(this).fadeIn()
                $loadMore.fadeOut()
                $loadLess.fadeIn()
            });
        })

        $loadLess.on('click', function () {
            $reviewList.find('.comment:not(:first-child),.review').each(function (i, el) {
                $loadLess.fadeOut()
                $loadMore.fadeIn()

                setTimeout(function () {
                    $(el).fadeOut()
                }, 500);
            });
        });
    })();

    (function redirectAfterChangeCategory() {
        $('#category-select').on('change', function () {
            window.location.href = $(this).val();
        });
    })();

    (function swipeCartItem() {
        $('.cart_item').each(function () {
            let startX = 0;
            let isSwiping = false;
            const $item = $(this);

            $item.on('touchstart', function (e) {
                startX = e.originalEvent.touches[0].clientX;
            });

            $item.on('touchmove', function (e) {
                const deltaX = e.originalEvent.touches[0].clientX - startX;
                if (deltaX < -20) {
                    isSwiping = true;
                }
            });

            $item.on('touchend', function () {
                if (isSwiping) {
                    $item.addClass('swiped');
                } else {
                    $item.removeClass('swiped');
                }
                isSwiping = false;
            });
        });
    })();

    (function removeItemFromCart() {
        $('.custom-delete-button .remove').each(function () {
            $(this).on('click touchend', function () {
                window.location.href = $(this).attr('href');
            })
        })
    })();

    (function setPerPageDependingOnInnerWidth() {
        let perPage = window.innerWidth <= 768 ? 8 : 12;
        document.documentElement.dataset.perPage = perPage;
        document.cookie = "per_page=" + perPage + "; path=/";
    })();

    (function () {
        $('#reply-title').remove();

        $('form.wc-block-checkout__form input[type="tel"]').mask('+1 (000) 000-0000');
    })();

    (function addCartQuantity(){
        $('div.woocommerce').on('change', '.qty', function () {
            $('.update_cart').removeAttr('disabled').trigger('click');
        });

        $(document).on('click', 'button.plus, button.minus', function () {
            const qty = $(this).parent('.quantity').find('.qty');
            const val = parseFloat(qty.val());
            const max = parseFloat(qty.attr('max'));
            const min = parseFloat(qty.attr('min'));
            const step = parseFloat(qty.attr('step')) || 1;
            const updateButton = document.querySelector('.update_cart');

            function triggerUpdate() {
                if (!updateButton) {
                    return;
                }
                updateButton.removeAttribute('disabled');
                updateButton.setAttribute('aria-disabled', 'false');
                updateButton.click();
            }

            if ($(this).is('.plus')) {
                qty.val(max && max <= val ? max : val + step).change();
                triggerUpdate();
            } else if (min && min >= val) {
                qty.val(min).change();
                triggerUpdate();
            } else if (val > 1) {
                qty.val(val - step).change();
                triggerUpdate();
            }
        });
    })();
});